"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = require("./i18n");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FulfillmentLocationTitle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FulfillmentLocationTitle, _React$Component);

  function FulfillmentLocationTitle() {
    _classCallCheck(this, FulfillmentLocationTitle);

    return _possibleConstructorReturn(this, _getPrototypeOf(FulfillmentLocationTitle).apply(this, arguments));
  }

  _createClass(FulfillmentLocationTitle, [{
    key: "style",
    value: function style(styles) {
      if (this.props.disableInlineStyles) {
        return undefined;
      }

      return styles;
    }
  }, {
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "render",
    value: function render() {
      var loc = this.props.location;
      return _react.default.createElement("div", {
        className: "cmpr-fl-title"
      }, _react.default.createElement("div", {
        className: "clearfix",
        style: this.style({
          position: "relative",
          marginBottom: "10px"
        })
      }, _react.default.createElement("div", {
        className: "pull-left"
      }, _react.default.createElement("div", {
        className: "cmpr-fl-title-caption"
      }, this.tt('fulfiller')), _react.default.createElement("h3", {
        className: "card-title",
        style: this.style({
          display: "inline"
        })
      }, loc.FulfillerName)), _react.default.createElement("div", {
        className: "pull-left"
      }, _react.default.createElement("div", {
        className: "cmpr-fl-title-caption"
      }, "\xA0"), _react.default.createElement("h3", {
        style: this.style({
          display: "inline"
        })
      }, "\xA0 \u2022 \xA0")), _react.default.createElement("div", {
        className: "pull-left"
      }, _react.default.createElement("div", {
        className: "cmpr-fl-title-caption"
      }, this.tt('location')), _react.default.createElement("h3", {
        style: this.style({
          display: "inline"
        })
      }, loc.FulfillmentLocationName)), _react.default.createElement("div", {
        className: "pull-right cmpr-fr-title-ids",
        style: this.style({
          position: "absolute",
          right: "0px",
          bottom: "4px"
        })
      }, _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "cmpr-fl-title-caption"
      }, this.tt('fulfiller'), ":\xA0"), loc.FulfillerId, this.props.showInternalIds ? _react.default.createElement("span", {
        className: "text-muted"
      }, "\xA0/\xA0", loc.InternalFulfillerId) : null), _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "cmpr-fl-title-caption"
      }, this.tt('location'), ":\xA0"), loc.FulfillmentLocationId, this.props.showInternalIds ? _react.default.createElement("span", {
        className: "text-muted"
      }, "\xA0/\xA0", loc.InternalFulfillmentLocationId) : null))), _react.default.createElement("hr", null));
    }
  }]);

  return FulfillmentLocationTitle;
}(_react.default.Component);

FulfillmentLocationTitle.propTypes = {
  onClick: _propTypes.default.func,
  location: _propTypes.default.object.isRequired,
  showInternalIds: _propTypes.default.bool,
  disableInlineStyles: _propTypes.default.bool,
  language: _propTypes.default.string,
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any
};
FulfillmentLocationTitle.defaultProps = {
  showInternalIds: true,
  disableInlineStyles: false,
  language: 'en'
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(FulfillmentLocationTitle);

exports.default = _default;